export enum ReportCustomizationReducerActions {
  ChangeReportType = "ChangeReportType",
  ChangeMemberships = "ChangeMemberships",

  ChangeTimeslice = "ChangeTimeslice",
  ChangeIsCompareMode = "ChangeIsCompareMode",
  ChangeComparedTimeslice = "ChangeComparedTimeslice",
  ChangeChangedGapsFilter = "ChangeChangedGapsFilter",

  ChangeFilename = "ChangeFilename",
  ChangeFileFormat = "ChangeFileFormat",
  ChangeReportFormat = "ChangeReportFormat",

  ChangeSharedUsers = "ChangeSharedUsers",
  ChangeShouldEmailLink = "ChangeShouldEmailLink",

  ChangeSelectedCounties = "ChangeSelectedCounties",
  ChangeSelectedStates = "ChangeSelectedStates",
  ChangeServiceAreaGapsType = "ChangeServiceAreaGapsType",
  ChangeIncludeActive = "ChangeIncludeActive",
  ChangeIncludePending = "ChangeIncludePending",
  ChangeIncludeApproved = "ChangeIncludeApproved",
  ChangeIncludeOpportunity = "ChangeIncludeOpportunity",
  ChangeSelectedZipClasses = "ChangeSelectedZipClasses",
  ChangeExcludeZeroMembership = "ChangeExcludeZeroMembership",

  ChangeSelectedSpecialties = "ChangeSelectedSpecialties",
  ChangeSpecialtyGapsType = "ChangeSpecialtyGapsType",
  ChangeIncludePhysicianSpecialties = "ChangeIncludePhysicianSpecialties",
  ChangeIncludeFacilitySpecialties = "ChangeIncludeFacilitySpecialties",
  ChangeIncludeExpandableSpecialties = "ChangeIncludeExpandableSpecialties",
  ChangeOnlyShowSpecialtiesNotMeetingAccess = "ChangeOnlyShowSpecialtiesNotMeetingAccess",

  ChangeProviderSource = "ChangeProviderSource",
  ChangeAppendNextClosestProviders = "ChangeAppendNextClosestProviders",
  ChangeAppendPatternOfCare = "ChangeAppendPatternOfCare",
  ChangeProviderFilter = "ChangeProviderFilter",
  ChangeShowAddedProviders = "ChangeShowAddedProviders",
  ChangeShowMatchedProviders = "ChangeShowMatchedProviders",
  ChangeShowRemovedProviders = "ChangeShowRemovedProviders",

  ChangeIncludeCargo = "ChangeIncludeCargo",

  ChangeSelectedCareJourneyCostValues = "ChangeSelectedCareJourneyCostValues",
  ChangeSelectedCareJourneyQualityValues = "ChangeSelectedCareJourneyQualityValues",
  ChangeSelectedEffectivenessValues = "ChangeSelectedEffectivenessValues",
  ChangeSelectedEfficiencyValues = "ChangeSelectedEfficiencyValues",
  ChangeSelectedLineOfBusiness = "ChangeSelectedLineOfBusiness",
  ChangeSelectedLocationConfidenceValues = "ChangeSelectedLocationConfidenceValues",
  ChangeSelectedMotiveAppropriatenessValues = "ChangeSelectedMotiveAppropriatenessValues",
  ChangeSelectedNewPatientClaimsValues = "ChangeSelectedNewPatientClaimsValues",
  ChangeSelectedVolumeLabels = "ChangeSelectedVolumeLabels",

  ChangeLoadedPresets = "ChangeLoadedPresets",
  ChangeSelectedPreset = "ChangeSelectedPreset",

  ChangeRunFrequency = "ChangeRunFrequency",

  LoadPage = "LoadPage",
  ChangeIsGenerating = "ChangeIsGenerating",
}